@if (state$ | async; as state) {
  <div ngbAccordion [closeOthers]="true" class="facet-accordion-styles">
    <div ngbAccordionItem [collapsed]="true" class="pl-0 mb-2">
      <div ngbAccordionHeader class="d-flex">
        <button ngbAccordionButton class="btn btn-link d-flex justify-content-between align-items-center">
          <div class="d-flex">{{facet.name}}</div>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          @switch (facet.name) {
            @case ('Flush Volume') {
              <ng-template>
                @for (value of facet.values; track value) {
                  <a #facetValue routerLink="./" [queryParams]="getLinkParams(value)"
                    class="value flushVolume" [class.selected]="value.selected" [cxFocus]="value.name"
                    (keydown.space)="openLink($event)" (click)="linkClick()">
                    <span>
                      <span class="label">{{ value.name }}</span>
                      <!-- <span class="count">{{ value.count }}</span> -->
                    </span>
                  </a>
                }
              </ng-template>
            }
            @default {
              @for (value of facet.values | slice: 0:state.topVisible; track value) {
                <a #facetValue routerLink="./"
                  [queryParams]="getLinkParams(value)" class="value" [class.selected]="value.selected"
                  [cxFocus]="value.name" (keydown.space)="openLink($event)" (click)="linkClick()">
                  <span>
                    @if (facet.name === 'Finish') {
<i class="fas fa-circle fa-lg pb-2 pt-2 pr-1" [ngClass]="{
                          'finish-graphite': value.name === 'Graphite',
                          'finish-brushed-nickel': value.name === 'Brushed Nickel',
                          'finish-brushed-stainless': value.name === 'Brushed Stainless',
                          'finish-polished-brass': value.name === 'Polished Brass',
                          'finish-polished-chrome': value.name === 'Polished Chrome',
                          'finish-rough-brass': value.name === 'Rough Brass',
                          'finish-satin-brass': value.name === 'Satin Brass',
                          'finish-gun-metal': value.name === 'Gun Metal',
                          'finish-matte-black': value.name === 'Matte Black',
                          'finish-matte-white': value.name === 'Matte White',
                          'finish-off-white': value.name === 'Off White',
                          'finish-polished-white': value.name === 'Polished White',
                          'finish-white': value.name === 'White'
                        }"></i>
                    }
                    <span class="label">
                      {{
                      value.name === 'true' || value.name === 'false'
                      ? value.name === 'true'
                      ? 'Yes'
                      : 'No'
                      : value.name
                      }}
                    </span>
                    <span class="count">{{ value.count }}</span>
                  </span>
                </a>
              }
              <div class="show-more">
                @for (value of facet.values | slice: state.topVisible:state.maxVisible; track value) {
                  <a #facetValue
                    routerLink="./" [queryParams]="getLinkParams(value)" class="value" [class.selected]="value.selected"
                    [cxFocus]="value.name" (keydown.space)="openLink($event)">
                    <span>
                      <span class="label">{{ value.name }}</span>
                      <span class="count">{{ value.count }}</span>
                    </span>
                  </a>
                }
                @if (state.maxVisible > state.topVisible) {
                  <button (click)="decreaseVisibleValues()"
                    class="cx-action-link text-decoration-none font-text-600 font-size-17 pt-2" cxFocus="moreorless">
                    {{ 'productList.showLess' | cxTranslate }}
                  </button>
                }
                @if (state.maxVisible > 0 && state.maxVisible < facet.values.length) {
                  <button
                    (click)="increaseVisibleValues()"
                    class="cx-action-link text-decoration-none font-text-600 font-size-17 pt-2" cxFocus="moreorless">
                    {{ 'productList.showMore' | cxTranslate }}
                  </button>
                }
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
  <!-- <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0" [closeOthers]="false">
  <ngb-panel [title]="facet.name" class="p-0">
    <ng-container [ngSwitch]="facet.name">
      <ng-container *ngSwitchCase="'Flush Volume'">
        <ng-template ngbPanelContent>
          <a *ngFor="let value of facet.values" #facetValue routerLink="./" [queryParams]="getLinkParams(value)"
            class="value flushVolume" [class.selected]="value.selected" [cxFocus]="value.name"
            (keydown.space)="openLink($event)" (click)="linkClick()">
            <span>
              <span class="label">{{ value.name }}</span>
              <span class="count">{{ value.count }}</span>
            </span>
          </a>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-template ngbPanelContent>
          <a *ngFor="let value of facet.values | slice: 0:state.topVisible" #facetValue routerLink="./"
            [queryParams]="getLinkParams(value)" class="value" [class.selected]="value.selected"
            [cxFocus]="value.name" (keydown.space)="openLink($event)" (click)="linkClick()">
            <span>
                <i *ngIf="facet.name === 'Finish'" class="fas fa-circle fa-lg pb-2 pt-2 pr-1" [ngClass]="{
                    'finish-graphite': value.name === 'Graphite',
                    'finish-brushed-nickel': value.name === 'Brushed Nickel',
                    'finish-brushed-stainless': value.name === 'Brushed Stainless',
                    'finish-polished-brass': value.name === 'Polished Brass',
                    'finish-polished-chrome': value.name === 'Polished Chrome',
                    'finish-rough-brass': value.name === 'Rough Brass',
                    'finish-satin-brass': value.name === 'Satin Brass',
                    'finish-gun-metal': value.name === 'Gun Metal',
                    'finish-matte-black': value.name === 'Matte Black',
                    'finish-matte-white': value.name === 'Matte White',
                    'finish-off-white': value.name === 'Off White',
                    'finish-polished-white': value.name === 'Polished White',
                    'finish-white': value.name === 'White'
                  }"></i>
              <span class="label">
                {{
                value.name === 'true' || value.name === 'false'
                ? value.name === 'true'
                ? 'Yes'
                : 'No'
                : value.name
                }}
              </span>
              <span class="count">{{ value.count }}</span>
            </span>
          </a>
          <div class="show-more">
            <a *ngFor="let value of facet.values | slice: state.topVisible:state.maxVisible" #facetValue
              routerLink="./" [queryParams]="getLinkParams(value)" class="value" [class.selected]="value.selected"
              [cxFocus]="value.name" (keydown.space)="openLink($event)">
              <span>
                <span class="label">{{ value.name }}</span>
                <span class="count">{{ value.count }}</span>
              </span>
            </a>
            <button *ngIf="state.maxVisible > state.topVisible" (click)="decreaseVisibleValues()"
              class="cx-action-link text-decoration-none font-text-600 font-size-17 pt-2" cxFocus="moreorless">
              {{ 'productList.showLess' | cxTranslate }}
            </button>
            <button *ngIf="state.maxVisible > 0 && state.maxVisible < facet.values.length"
              (click)="increaseVisibleValues()"
              class="cx-action-link text-decoration-none font-text-600 font-size-17 pt-2" cxFocus="moreorless">
              {{ 'productList.showMore' | cxTranslate }}
            </button>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </ngb-panel>
</ngb-accordion> -->
}
